// extracted by mini-css-extract-plugin
export default {"feedbackButton":"FeedbackButton_feedbackButton__OsJS4","slideInLeft":"FeedbackButton_slideInLeft__XTPYM","pulse":"FeedbackButton_pulse__2jUIA"};